// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"_1uiqzzD4","section":"_2R_PQ7xR","buttonCol":"_1RLTeL9K","headerButton":"efUoiyoT","content":"_1ELL1Je5"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/pages/HomePage/components/Speak/Speak.styl
// module id = 253
// module chunks = 0